import { storage } from '@/shared/utils';

export const logout = (): void => {
  storage.clearTokens();
  // TODO: Add backend logout endpoint call if needed
  // await api.post('/api/v1/auth/logout');
};
